import React, { useState, useEffect } from 'react'
import {Flex, TextButton, Spinner} from '/app/src/component'
import CompanyModel from '/app/src/model/Company/model';
import style from './style.scss'
import SVG from 'react-inlinesvg';
import Theme from '/app/src/theme';
import SelectInput from '/app/src/component/Forms/SelectInput';


export default function RatingStats() {
    const [selectedEmployee, setSelectedEmployee] = useState(0)
    const [isLoading, setIsLoading] = useState(true)
    const [stars, setStars] = useState([0, 0, 0, 0, 0])
    const [employeeDictionary] = useState({});
    const [ratingData, setRatingData] = useState()
    useEffect( () => {
        // HACK: Memory leak without checking if component is mounted. Reasons unknown.
        let _mounted = true;
        try{
            CompanyModel.getLatestRatingsRequest()
                .then( res => {
                    if (_mounted) {
                        setRatingData(res.body.stats);
                        let employeeSet = new Set();
                        let tempStars = [0, 0, 0, 0, 0];
                        Object.keys(res.body.stats).forEach((element, index)=> {
                            employeeSet.add(element);
                            let employeeRatings = res.body.stats[element];
                            employeeRatings.forEach(element=>{
                                let rating = element["rating"];
                                let nbr_ratings = element["nbr_tickets"];
                                tempStars[rating-1] += nbr_ratings;
                            })
                        });
                        let sortedEmployees = Array.from(employeeSet).sort();
                        setStars(tempStars);
                        if(sortedEmployees.length > 1){
                            employeeDictionary[0] = "Alla medarbetare";
                        }
                        sortedEmployees.forEach((element, index)=> {
                            employeeDictionary[index+1] = element;
                        });
                        setIsLoading(false);
                    }})
        } catch (e) {
            console.log(e)
        }
        return () => _mounted = false;
    }, [] )

    /**
     * Places filled/unfilled stars to form the visual representation of the five ratings
     * @returns Flexbox with stars
     */
    function renderStars() {
        return (
            <Flex direction="column" style={{padding: "15px 0 0 80px"}}>
                {
                    [...Array(5)].map((_, i) => (
                        <Flex key={i} style={{marginTop: "2.5px", marginBottom: "2.5px"}}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', marginRight: "5px" }}>
                                <p style={{ fontSize: 25, minWidth: "30px", textAlign: "right", marginRight: "10px", justifyContent: 'center'}}>
                                    {stars[4-i]}
                                </p>
                            </div>
                            {[...Array(5)].map((_, j) => {
                                return (
                                    <SVG
                                        src={5-i > j ? "/images/ratingStar_Filled.svg" : "/images/ratingStar_Outline.svg"}
                                        style={{
                                            fill: Theme.colors.blue,
                                            width: "35px",
                                            height: "35px",
                                            marginRight: "5px",
                                            justifyContent: 'top'
                                        }}
                                    />
                                );
                            })}
                        </Flex>
                    ))
                }
            </Flex>
        );
    }
    /**
     * When a new employee is selected, the ratings are updated to reflect the selected employee and the SelectInput element is updated
     * @param {*} event
     */
    function updateEmployee(event){
        setSelectedEmployee(event.target.value);
        let selectedName = employeeDictionary[event.target.value];
        let tempStars = [0, 0, 0, 0, 0];
        let relevantData;
        if (event.target.value == 0){
            relevantData = ratingData;
        } else{
            relevantData = {[selectedName]: ratingData[selectedName]};
        }
        Object.keys(relevantData).forEach((element, index)=> {
            let employeeRatings = ratingData[element];
            employeeRatings.forEach(element=>{
                let rating = element["rating"];
                let nbr_ratings = element["nbr_tickets"];
                tempStars[rating-1] += nbr_ratings;
            })
        });
        setStars(tempStars);
    }

    return (
    <Flex className="container"  bg='LightGray1' borderRadius='36px' minWidth="500px" mt='30px'>
        {isLoading ? <Spinner  type='loading' /> :
        <Flex direction="column" style={{padding: "20px 25px 20px 25px"}}>
            <Flex fontSize='36px' color='black' fontWeight='300' style={{padding: "0 0 10px 0"}}>Besökaromdömen</Flex>
            <Flex>
                <Flex direction="column" style={{padding: "0 0 0 0"}} minWidth="200px">
                    <SelectInput values={employeeDictionary} select={selectedEmployee} onChange={updateEmployee}/>
                    <p style={{fontSize: "16px", color: "black", fontWeight: "300", padding: "15px 0 5px 0"}}>Betygsatta ärenden</p>
                    <p style={{fontSize: "36px", color: "black", fontWeight: "300", padding: "0 0 0 0"}}>{stars.reduce((accumulator, currentValue) => accumulator + currentValue, 0)}</p>
                </Flex>
                {renderStars()}
            </Flex>
        </Flex>
        }
    </Flex>
    )
}


// WEBPACK FOOTER //
// ./src/component/RatingStats/index.js